import { render, staticRenderFns } from "./Establecimientos.vue?vue&type=template&id=066ada8c&scoped=true&"
import script from "./Establecimientos.vue?vue&type=script&lang=js&"
export * from "./Establecimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ada8c",
  null
  
)

export default component.exports